import { CrashlyticsService } from "app/core/crashlytics/crashlytics.service";

/**
 * Module-level bridge to Crashlytics for code that runs outside Angular's
 * injection context (plain helper functions, utilities).
 *
 * `inject()` only works inside an injection context, so a standalone function
 * called from a component method cannot reach a service.
 * The provider registers the singleton here once at startup, and helpers report through
 * these functions instead.
 *
 * Every call before registration -- and on the web build, where the service
 * no-ops -- is silently discarded rather than throwing.
 */
let reporter: CrashlyticsService | null = null;

export function registerCrashlyticsReporter(service: CrashlyticsService): void {
  reporter = service;
}

export function reportException(error: unknown, context: string): void {
  try {
    void reporter?.recordException(error, context);
  } catch {
    // Reporting must never surface as an application failure.
  }
}

export function reportLog(message: string): void {
  try {
    void reporter?.log(message);
  } catch {
    // Reporting must never surface as an application failure.
  }
}

export function reportCustomKey(key: string, value: string): void {
  try {
    void reporter?.setCustomKey(key, value);
  } catch {
    // Reporting must never surface as an application failure.
  }
}
